"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Config_1 = require("../Config/Config");
const FetchProxy_1 = require("../Utility/FetchProxy");
const QueryResult_1 = require("./QueryResult");
class Query {
    constructor(select) {
        this.query = {};
        this.query = {
            query: select,
        };
    }
    with(...tables) {
        this.query.with = tables;
        return this;
    }
    link(left, right) {
        if (this.query.link === undefined)
            this.query.link = [];
        this.query.link.push({
            left: left,
            right: right
        });
        return this;
    }
    where(left, op, right, linkWith) {
        if (this.query.where === undefined)
            this.query.where = [];
        let where = {
            left: left,
            op: op,
        };
        if (op !== "IS NOT NULL" && op !== "IS NULL") {
            where.right = right;
        }
        if (linkWith !== undefined) {
            where.linkWith = linkWith;
        }
        this.query.where.push(where);
        return this;
    }
    orderBy(column, direction) {
        if (this.query.orderBy === undefined)
            this.query.orderBy = [];
        this.query.orderBy.push({
            column: column,
            direction: direction
        });
        return this;
    }
    limit(lower, upper) {
        this.query.limit = [lower, upper];
        return this;
    }
    filter(...columns) {
        this.query.filter = columns;
        return this;
    }
    async get() {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/query/wrap`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(this.query)
            }).auth(false).fetch();
            const json = await res.json();
            return new QueryResult_1.default(json);
        }
        catch (err) {
            throw new Error(`Query fail: status ${err.message}`);
        }
    }
}
exports.default = Query;
//# sourceMappingURL=Query.js.map